
import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { OrderUpdateStatusCommand, OrderUpdateStatusCommandBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(OrderUpdateStatusCommand)
@Injectable({ providedIn: 'root'})
export class OrderUpdateStatusCommandHandler {
	private commandHandler: OrderUpdateStatusCommandBase;
	public constructor(
		@Inject(Http) http: HttpService
	) {
		this.commandHandler = new OrderUpdateStatusCommandBase(http);
	}

	public async handleAsync(query: OrderUpdateStatusCommand): Promise<any> {
		return await this.commandHandler.handleAsync(query);
	}
}
